<template>
  <component :is="tag" :to="path" class="wrap-link folder__item-wrap">
    <v-card class="folder__item" text ripple>
      <div class="folder-icon">
        <icon-base icon="custom/folder" alt="" />
        <span class="items-count">
          <slot name="count">
            {{ itemsCount }}
          </slot>
        </span>
      </div>
      <p class="folder-title" v-html="name"></p>

      <slot name="actions" />
    </v-card>
  </component>
</template>

<script>
export default {
  name: 'FolderCard',
  props: {
    path: [String, Object],
    name: String,
    itemsCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    tag() {
      return this.path ? 'router-link' : 'div';
    },
  },
};
</script>

<style lang="less" src="@/assets/styles/basic/folder.less"></style>
